
export function formatWorkOrderAddress(wo) {
  if (!wo || typeof wo !== "object") return "";
  const line1 = wo.address1 != null && String(wo.address1).trim();
  const line2 = wo.address2 != null && String(wo.address2).trim();
  if (line1 && line2) return `${line1}, ${line2}`;
  if (line1) return line1;
  if (line2) return line2;
  return "";
}
